var _react_refresh_temp_1;
import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, workspaceStatusParser } from '#validation';
import { paginatedResponse } from '#web-service-api/common';
export const PartnerOrganizationWorkspaceListItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: workspaceStatusParser,
    filespacesCount: z.number(),
    membersCount: z.number(),
    usedStorageGb: z.number(),
    createdAt: dateParser(),
    owner: z.object({
        email: z.email(),
    }),
    canChangeOwner: z.boolean(),
});
export const PartnerOrganizationWorkspacesListResponseSchema = paginatedResponse(PartnerOrganizationWorkspaceListItemSchema);
_react_refresh_temp_1 = PartnerOrganizationWorkspacesListResponseSchema;
$RefreshReg$(_react_refresh_temp_1, "PartnerOrganizationWorkspacesListResponseSchema");
export class PartnerOrganizationWorkspacesListResponseDto extends createZodDto(PartnerOrganizationWorkspacesListResponseSchema) {
}
export const PartnerOrganizationDirectWorkspaceListItemSchema = PartnerOrganizationWorkspaceListItemSchema.pick({ id: true, name: true });
export const PartnerOrganizationDirectWorkspacesListResponseSchema = z.object({
    items: z.array(PartnerOrganizationDirectWorkspaceListItemSchema),
    owner: z.object({
        email: z.email(),
    }),
});
export class PartnerOrganizationDirectWorkspacesListResponseDto extends createZodDto(PartnerOrganizationDirectWorkspacesListResponseSchema) {
}
